import * as states from './constants';
import addressFormReducer from './components/AddressForm/AddressFormReducer';
import confirmPrimaryCareReducer from './components/ConfirmPrimaryCare/ConfirmPrimaryCareReducer';
import referringPhysicianReducer from './components/ReferringPhysician/ReferringPhysicianReducer';
import obgynConfirmationReducer from './components/OBGYNConfirmation/OBGYNConfirmationReducer';
import confirmAgeWarningReducer from './components/AgeWarningConfirmation/AgeWarningConfirmationReducer';
import usingInsuranceConfirmationReducer from './components/UsingInsuranceConfirmation/usingInsuranceConfirmationReducer';
import { REQUIREMENTS_VALIDATION_CHANGE } from './AppointmentRequirementsActions';
import { combineReducers } from 'redux';

export function appointmentRequirementsValidationReducer(state = true, action) {
    const { type, payload } = action;

    switch (type) {
        case REQUIREMENTS_VALIDATION_CHANGE:
            return payload.isValid;
        default:
            return state;
    }
}

const appointmentRequirementsReducer = combineReducers({
    [states.USING_INSURANCE_STATE_KEY]: usingInsuranceConfirmationReducer,
    [states.REQUIREMENTS_VALIDATION_KEY]: appointmentRequirementsValidationReducer,
    [states.PRIMARY_CARE_CONFIRMATION_STATE_KEY]: confirmPrimaryCareReducer,
    [states.REFERRING_PHYSICIAN_STATE_KEY]: referringPhysicianReducer,
    [states.ADDRESS_FORM_STATE_KEY]: addressFormReducer,
    [states.OBGYN_CONFIRMATION_STATE_KEY]: obgynConfirmationReducer,
    [states.AGE_WARNING_CONFIRMATION_STATE_KEY]: confirmAgeWarningReducer,
});

export default appointmentRequirementsReducer;
